import {SingleSelectProps} from "../../../../components-shared/select/single-select"
import React, {useContext} from "react"
import {FormSingleSelect} from "../../../../components-shared/forms/form-single-select/form-single-select"
import {CategoryHelper, CategoryHelperContext} from "../../../../services/helpers/category-helper"

export interface FormCategorySelectProps extends Pick<SingleSelectProps, "selectedItemId" | "personalData" | "disabled" | "onChange" | "showValidity" | "validationResult"> {
  allCategories?: boolean
  label?: string
  includeTopCategories?: boolean
}

export const FormCategorySelect: React.FC<FormCategorySelectProps> = (props) => {
  const categoryHelper = useContext<CategoryHelper | null>(CategoryHelperContext)
  if (categoryHelper === null) return null

  const categories = props.includeTopCategories === true
    ? categoryHelper.categoriesIncludingTopLevel
    : categoryHelper.flatSubCategories

  const categorySelectItems: Array<{id: number | null, component: string}> = categories.map(category => {
    return {id: category.id, component: category.fullName}
  })

  if (props.allCategories === true) {
    categorySelectItems.unshift({id: null, component: "Alle categorieën"})
  }
  else {
    categorySelectItems.unshift({id: null, component: ""})
  }

  props = {...props, selectedItemId: props.selectedItemId ?? null}

  return <FormSingleSelect label={props.label || "Categorie"} items={categorySelectItems} {...props}/>
}

